import React from "react";
import { useTranslation } from "react-i18next";

import CompanyInfo from "components/companyInfo";
import Icon from "components/icon";
import { icons } from "components/icon/icons";

import { privacyPolicyContent } from "./content";

const product_version = process.env.REACT_APP_PRODUCT_VERSION;

const PublicPrivacyPolicy = () => {
  const { i18n } = useTranslation();
  const isPortuguese = i18n.language && i18n.language.toLowerCase().startsWith("pt");
  const content = isPortuguese ? privacyPolicyContent.pt : privacyPolicyContent.en;

  return (
    <div className="col profile-body">
      <div className="row-space-between">
        <Icon icon={icons["company-logo"]} alt="company-logo" />
        <div>
          <Icon icon={icons["serial-number-icon"]} alt="snIcon" />
          <span className="regular-text">
            {product_version === "" ? "Error" : product_version}
          </span>
        </div>
      </div>
      <div className="body-text-wrapper public-privacy-policy">
        <h1 className="public-privacy-policy__title">{content.title}</h1>
        <div className="public-privacy-policy__subtitle">{content.subtitle}</div>
        <div className="body-text regular-text black-color">
          {content.sections.map((section, index) => (
            <section key={index} className="public-privacy-policy__section">
              <h3 className="public-privacy-policy__heading">{section.heading}</h3>
              {section.body}
            </section>
          ))}
        </div>
      </div>
      <div className="d-flex center-justify">
        <CompanyInfo />
      </div>
    </div>
  );
};

export default React.memo(PublicPrivacyPolicy);
